export function classificarFalhaEnvioSenha(error, traduzir, mensagemApi) {
  const statusHttp = error?.response?.status;
  if (!statusHttp || statusHttp === 408 || statusHttp >= 500) {
    return {
      status: "incerto",
      motivo: traduzir(
        statusHttp
          ? "Servidor_nao_confirmou_envio_senha"
          : "Sem_resposta_envio_senha"
      ),
    };
  }
  if (statusHttp === 404) {
    return {
      status: "falha",
      motivo: traduzir("Usuario_nao_encontrado_envio_senha"),
    };
  }
  if (statusHttp === 401 || statusHttp === 403) {
    return {
      status: "falha",
      motivo: traduzir("Sem_permissao_envio_senha"),
    };
  }
  return {
    status: "falha",
    motivo: mensagemApi(error, traduzir("Motivo_envio_senha_indisponivel")),
  };
}

export async function processarEnvioNovaSenhaEmMassa(
  usuarios,
  enviar,
  registrarResultado,
  classificarErro,
  limiteSimultaneo = 3
) {
  const resultados = new Array(usuarios.length);
  let proximoIndice = 0;
  const processar = async () => {
    while (proximoIndice < usuarios.length) {
      const indice = proximoIndice++;
      let resultado;
      try {
        await enviar(usuarios[indice]);
        resultado = { status: "enviado" };
      } catch (error) {
        resultado = classificarErro(error);
      }
      resultados[indice] = resultado;
      registrarResultado(indice, resultado);
    }
  };

  await Promise.all(
    Array.from({ length: Math.min(limiteSimultaneo, usuarios.length) }, () =>
      processar()
    )
  );
  return resultados;
}
